import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplyCategoryQuery = gql`query get_supply_category{
  supply_categories(where: {status: {_eq: "ACTIVE"}},  order_by: {name: asc}){
    id
    name
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplyCategoryService {

  constructor(private apollo: Apollo) { }

  getSupplyCategory(){
    return this.apollo.use('external').query({
      query: getSupplyCategoryQuery
    }).pipe(pluck('data', 'supply_categories'));
  }
}
